export default function ProgramProgressSkeleton() {
    return (
        <div className="mt-1.5 animate-pulse">
            <div className="flex items-baseline justify-between mb-1">
                <div className="h-3 w-24 bg-gray-200 rounded" />
                <div className="h-3 w-6 bg-gray-200 rounded" />
            </div>
            <div className="h-1.5 w-full bg-gray-200 rounded-full" />
        </div>
    );
}
